// The one list's cards: every lesson bundle, quick group and warm-up
// assignment of the class, and the orders they can be shown in.

const cardTime = (card) => {
  const time = Date.parse(card.timestamp);
  return Number.isNaN(time) ? null : time;
};

const newestFirst = (a, b) => {
  const timeA = cardTime(a);
  const timeB = cardTime(b);
  if (timeA === timeB) return 0;
  if (timeA === null) return 1;
  if (timeB === null) return -1;
  return timeB - timeA;
};

export const cardsFrom = ({ lessons = [], quickGroups = [], warmUps = [] }) => [
  ...lessons.map((data) => ({ type: "lesson", data, timestamp: data.last_updated_at })),
  ...quickGroups.map((data) => ({ type: "quick", data, timestamp: data.last_updated })),
  ...warmUps.map((data) => ({ type: "warmUp", data, timestamp: data.last_updated })),
];

const TYPE_ORDER = ["lesson", "quick", "warmUp"];

const byType = (a, b) => TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type);

// Array.prototype.sort is stable, and cardsFrom lists lessons, then quick
// groups, then warm-ups, each in source order: so cards that compare equal keep
// exactly the tie order the list promises.
export const sortCards = (cards, sortBy) =>
  [...cards].sort(sortBy === "group_type" ? (a, b) => byType(a, b) || newestFirst(a, b) : newestFirst);

export const ALL_GROUP_TYPES = "all";

// Where the one list starts: newest first, every type.
export const DEFAULT_LIST_SETTINGS = { sortBy: "last_updated", groupType: "all" };

// Each Group Type option's value and the label it is counted under.
export const GROUP_TYPES = [
  { value: ALL_GROUP_TYPES, name: "All Group Types" },
  { value: "lesson", name: "Lesson Groups" },
  { value: "quick", name: "Quick Groups" },
  { value: "warmUp", name: "Warm-Up Groups" },
];

export const groupTypeName = (value) => GROUP_TYPES.find((type) => type.value === value)?.name;

export const filterCards = (cards, groupType) =>
  groupType === ALL_GROUP_TYPES ? cards : cards.filter((card) => card.type === groupType);

export const groupTypeOptions = (cards) =>
  GROUP_TYPES.map(({ value, name }) => ({ value, label: `${name} (${filterCards(cards, value).length})` }));

// What a lesson card renderer hands AssignmentAccordion for the one list:
// nothing at all on every other page.
export const oneListCardProps = (listCard) =>
  listCard
    ? {
        appearance: "oneList",
        expanded: listCard.expanded,
        onToggleExpanded: listCard.onToggleExpanded,
        editButtonId: listCard.editButtonId,
      }
    : {};
